import 'react-placeholder/lib/reactPlaceholder.css';

import * as React from 'react';
import ReactPlaceholder from 'react-placeholder';

interface IProps {
  loading?: boolean;
}

export const LoadingImage: React.SFC<
  IProps &
    React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >
> = props => {
  const { loading, ...attributes } = props;
  return (
    <ReactPlaceholder
      ready={!loading}
      showLoadingAnimation={true}
      type="rect"
      className={props.className}
    >
      <img {...attributes} />
    </ReactPlaceholder>
  );
};

export default LoadingImage;



// WEBPACK FOOTER //
// ./src/components/LoadingImage/LoadingImage.tsx